import { Api } from './ApiFzu'

export const apiFzu = new Api({
  baseURL: '/fzuapi/',
  timeout: 60000,
})
